import { ready } from 'brei-project-utils';
import { Splide } from '@splidejs/splide';

// Example of importing a custom module
// import { primaryNav } from './modules/primaryNav';

const main = {

	elem: {
		body: document.querySelector('body'),
		consentModal: document.querySelector('.cookie-consent'),
		consentButtons: document.querySelectorAll('.cookie-consent .btn'),
		couchSlider: document.querySelectorAll('.couch .splide'),
		navElement: document.querySelector('.navigation'),
		navToggle: document.querySelector('.navigation button'),
		videoButton: document.querySelectorAll('.video__button'),
		videoLink: document.querySelectorAll('.slider a'),
		videoModal: document.querySelector('.modal-video'),
		videoSlider: document.querySelectorAll('.slider')
	},

	consentStatus: localStorage.getItem('consentsToCookies'),	

	mql: {
		large: window.matchMedia('(min-width: 768px)')
	},	
	
	init() {

		main.elem.navToggle.addEventListener('click', main.navToggle);
		window.addEventListener('resize', main.navReset);		
		
		main.elem.videoButton.forEach(function(element) {
			element.addEventListener('click', main.videoInPlace);
			// junk
		});

		main.elem.videoLink.forEach(function(element) {
			element.addEventListener('click', main.videoModal);

		});		

		main.elem.videoModal.addEventListener('click', main.modalClose);
		main.elem.videoModal.addEventListener('close', main.modalReset);
		
		if(main.elem.couchSlider.length > 0) {
			main.elem.couchSlider.forEach((element) => {
				window.couchSplide = new Splide(element, {
					type: 'slide',
					perPage: 1,
					slidesToShow: 1,
					arrows: true,
					drag: true,
					pagination: false,
					mediaQuery: 'min',
					breakpoints: {
						1024: {
							direction: 'ttb',
							height: 'calc(100vh - 104px)'
						}
					}
				}).mount();
			});
		}		
		
		if(main.elem.videoSlider.length > 0) {
			main.elem.videoSlider.forEach((element) => {
				window.videoSplide = new Splide(element, {
					type: 'fade',
					perPage: 1,
					slidesToShow: 1,
					arrows: true,
					arrowPath: 'M28.7,17.4L15.5,1.1c-1.2-1.4-3.1-1.4-4.2,0-1.2,1.4-1.2,3.8,0,5.2l11.1,13.7-11.1,13.7c-1.2,1.4-1.2,3.8,0,5.2s1.4,1.1,2.1,1.1,1.5-.4,2.1-1.1l13.2-16.3c1.2-1.4,1.2-3.8,0-5.2h0Z',
					drag: true,
					pagination: false
				}).mount();
			});
		}

		if(main.consentStatus === null) {
			main.elem.consentModal.setAttribute('aria-hidden', 'false');

			main.elem.consentButtons.forEach(function (button) {

				button.addEventListener('click', function(event) {
					// 0. Get the value of the button clicked ("true" or "false")
					const userChoice = event.currentTarget.value;
					const isGranted = (userChoice === 'true');

					// 1. Save the choice to localStorage (Original functionality)
					localStorage.setItem('consentsToCookies', '{"value":' + userChoice + '}');

					// 2. Hide the modal (Original functionality)
					main.elem.consentModal.setAttribute('aria-hidden', 'true');
					main.elem.consentModal.style.display = 'none';

					// 3. Set conset properties based on button click
					const consentEvent = isGranted ? 'cookie_consent_accepted' : 'cookie_consent_declined';
					const consentUpdate = {
						'analytics_storage': isGranted ? 'granted' : 'denied',
						'ad_storage': isGranted ? 'granted' : 'denied',
						'ad_user_data': isGranted ? 'granted' : 'denied',
						'ad_personalization': isGranted ? 'granted' : 'denied'
					};

					// 4. Push updated consent status to GTM data layer
					// This command updates the consent state in Google Consent Mode (v2)
					window.dataLayer = window.dataLayer || [];
					if (typeof window.gtag === 'function') {
						window.gtag('consent', 'update', consentUpdate);
					} else {
						window.dataLayer.push(['consent', 'update', consentUpdate]);
					}

					// 5. follow-up event that GTM triggers on					
					window.dataLayer.push({ 'event': consentEvent });
					
				});
			});			
		}
	},

	modalClose(event) {
		if (event.target.nodeName !== 'VIDEO') {
			main.elem.videoModal.close();
		}
	},

	modalReset() {
		main.elem.body.classList.remove('video-modal-open');
		main.elem.videoModal.removeChild(main.elem.videoModal.querySelector('iframe, video'));
	},	

	navReset() {
		if(main.mql.large.matches) {
			main.elem.navElement.classList.remove('open');
			main.elem.navToggle.setAttribute('aria-expanded', false);
			main.elem.navToggle.setAttribute('aria-label', 'Open Menu');
			main.elem.navToggle.setAttribute('aria-pressed', false);
		}
	},	
	
	navToggle(e) {
		e.preventDefault();
		main.elem.navElement.classList.toggle('open');
		main.elem.navToggle.setAttribute('aria-expanded', main.reverse(main.elem.toggle.getAttribute('aria-expanded')));
		main.elem.navToggle.setAttribute('aria-label', main.replace(main.elem.toggle.getAttribute('aria-label')));
		main.elem.navToggle.setAttribute('aria-pressed', main.reverse(main.elem.toggle.getAttribute('aria-pressed')));

	},

	videoInPlace(event) {
		event.preventDefault();
		let parent = event.currentTarget.parentElement;
		let link = event.currentTarget.href;
		let id = '';
		let src = '';
		if (link.indexOf('youtube.com') > -1) {
			id = link.substr(link.indexOf('=') + 1);
			src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&modestrbranding=1&rel=0'
		}
		if (link.indexOf('youtu.be') > -1) {
			id = link.substr(17);
			id = id.split('?')[0];
			src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&modestrbranding=1&rel=0'
		}
		if (link.indexOf('vimeo.com') > -1) {
			id = link.split('/');
			if(id.length > 4) {
				src = 'https://player.vimeo.com/video/' + id[3] + '?h=' + id[4] + '&autoplay=1'
			} else {
				src = 'https://player.vimeo.com/video/' + id[3] + '?autoplay=1'
			}
		}	
		if (link.indexOf('player.vimeo.com') > -1) {
			id = link.split('/')[4];
			src = 'https://player.vimeo.com/video/' + id + '?autoplay=1'
		}
		console.log(parent);		
		parent.innerHTML = '<iframe class="video__item" frameborder="0" allow="autoplay" allow="autoplay; clipboard-write; encrypted-media; fullscreen; web-share" allowfullscreen referrerpolicy="strict-origin-when-cross-origin" sandbox="allow-same-origin allow-scripts allow-presentation" src="' + src + '"></iframe>';
	},

	videoModal(event) {
		event.preventDefault();
		let href = event.currentTarget.href;
		let id = '';
		let src= '';
		main.elem.body.classList.add('video-modal-open');	
		if(href.indexOf('.mp4') > -1) {
			main.elem.videoModal.innerHTML += '<video id="video-modal__embed" autoplay controls><source src="' + href + '"" type="video/mp4"></video>';			
		} else {
			if (href.indexOf('vimeo.com') > -1) {
				id = href.split('/');
				if(id.length > 4) {
					src = 'https://player.vimeo.com/video/' + id[3] + '?h=' + id[4] + '&autoplay=1'
				} else {
					src = 'https://player.vimeo.com/video/' + id[3] + '?autoplay=1'
				}
			}	
			if (href.indexOf('player.vimeo.com') > -1) {
				id = href.split('/')[4];
				src = 'https://player.vimeo.com/video/' + id + '?autoplay=1'
			}
			if (href.indexOf('youtube.com') > -1) {
				id = href.substr(href.indexOf('=') + 1);
				src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&modestrbranding=1&rel=0'
			}
			if (href.indexOf('youtu.be') > -1) {
				id = href.substr(17);
				id = id.split('?')[0];
				src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&modestrbranding=1&rel=0'
			}		
			main.elem.videoModal.innerHTML += '<iframe class="video-modal__iframe" frameborder="0" allow="autoplay" allow="autoplay; clipboard-write; encrypted-media; fullscreen; web-share" allowfullscreen referrerpolicy="strict-origin-when-cross-origin" sandbox="allow-same-origin allow-scripts allow-presentation" src="' + src + '"></iframe>';
		}
		main.elem.videoModal.showModal();
		main.elem.videoModal.querySelector('.modal-video__close').addEventListener('click', main.modalClose);		
	}	
	
};

ready(function () {
	main.init();
});
